import React from "react";
import "./Payment.css";
import chip from "../../img/chip.png";
import aceptado from "../../img/Aceptado.svg";

import {
    disabledButton, fillProducts, fillUtms, getCurrency, getDatas, getUtms,
    handleBlur, handleChange, handleCP, handleCVV, handleEmail,
    handleExpDate,
    handleFocus, handleNombre, handlePayment, handlePhone, handleRazonSocial, handleRFC,
    handleTarjeta,
    handleTitular, hidePage, makeContact, makeLogo, sendDatas, sendToGeneral, sendToGeneralPublic, setTable, showPage,
    updateCardAmount, updateCartNumber
} from "../extras/Actions";
import FondoCopos from "../Copitos/Copitos";

export default class Payment extends React.Component{

    componentDidMount() {
        getCurrency()
        setTable()
        getUtms();
        hidePage()
        fillUtms();
        fillProducts()
        updateCardAmount()
        updateCartNumber()
        if (window.location.href.includes("payment") && localStorage.getItem("donors") !== null){
            makeLogo()
        }else{
            getDatas()
        }
        disabledButton(document.querySelector(".step-1 button"))
        setTimeout(showPage,3000)
    }

    render() {
        return (
            <div className="payment">
                <div className="step-1">
                    <h3>
                        Datos personales
                    </h3>
                    <div className="bank-datas">
                        <div className="datas">
                            <div className="data is-invalid">
                                <label htmlFor="">
                                    Nombre
                                </label>
                                <input type="text" id="first_name" onFocus={handleFocus} onKeyUp={handleNombre} onBlur={handleBlur}/>
                            </div>
                            <div className="data is-invalid">
                                <label htmlFor="">
                                    Apellidos
                                </label>
                                <input type="text" id="last_name" onFocus={handleFocus} onKeyUp={handleNombre} onBlur={handleBlur}/>
                            </div>
                            <div className="data is-invalid">
                                <label htmlFor="">
                                    Correo electrónico
                                </label>
                                <input type="text" id="email" onFocus={handleFocus} onKeyUp={handleEmail} onBlur={handleBlur}/>
                            </div>
                            <div className="data is-invalid">
                                <label htmlFor="">
                                    Número de teléfono
                                </label>
                                <input type="text" id="phone" onFocus={handleFocus} onKeyUp={handlePhone} onBlur={handleBlur}/>
                            </div>
                        </div>
                        <input type="hidden" id="utm_term"/>
                        <input type="hidden" id="utm_campaign"/>
                        <input type="hidden" id="utm_source"/>
                        <input type="hidden" id="utm_content"/>
                        <input type="hidden" id="utm_medium"/>
                        <input type="hidden" id="currency" name="currency"/>
                        <button onClick={makeContact}>
                            Continuar
                        </button>
                    </div>
                </div>
                <div className="step-2 d-none">
                    <div className="card generic">
                        <div className="bank">
                            <div className="bank_name">
                                ----- ---
                            </div>
                            <div className="card-amount">
                                $2,500.00
                            </div>
                        </div>
                        <div className="icons">
                            <img src={chip} alt=""/>
                        </div>
                        <div className="card-number">
                            <div id="digit1">-</div>
                            <div id="digit2">-</div>
                            <div id="digit3">-</div>
                            <div id="digit4">-</div>
                            <div id="digit5">-</div>
                            <div id="digit6">-</div>
                            <div id="digit7">-</div>
                            <div id="digit8">-</div>
                            <div id="digit9">-</div>
                            <div id="digit10">-</div>
                            <div id="digit11">-</div>
                            <div id="digit12">-</div>
                            <div id="digit13">-</div>
                            <div id="digit14">-</div>
                            <div id="digit15">-</div>
                            <div id="digit16">-</div>
                        </div>
                        <div className="extras">
                            <div className="titular">
                                ---- ---- ---- ----
                            </div>
                            <div className="expiration-date">
                                --/--
                            </div>
                        </div>
                    </div>
                    <div className="bank-datas">
                        <h3>
                            Datos bancarios
                        </h3>
                        <div className="datas">
                            <div className="data">
                                <label htmlFor="">
                                    Nombre completo del titular
                                </label>
                                <input type="text" id="titular" onKeyUp={handleTitular} onFocus={handleFocus} onBlur={handleBlur}/>
                            </div>
                            <div className="data">
                                <label htmlFor="">
                                    Número de tarjeta
                                </label>
                                <input type="text" id="tarjeta" onKeyUp={handleTarjeta} onFocus={handleFocus} onBlur={handleBlur}/>
                            </div>
                            <div className="middle">
                                <div className="data">
                                    <label htmlFor="">
                                        Fecha de expiración
                                    </label>
                                    <input type="text" id="exp_date" onKeyUp={handleExpDate} onFocus={handleFocus} onBlur={handleBlur}/>
                                </div>
                                <div className="data">
                                    <label htmlFor="">
                                        CVV
                                    </label>
                                    <input type="text" id="cvv" onFocus={handleFocus} onKeyUp={handleCVV} onBlur={handleBlur}/>
                                </div>
                            </div>
                            <div className="data anonimo is-valid">
                                <input type="checkbox" name="anonimo" id="anonimo"/>
                                <label htmlFor="anonimo">Deseo que mi donativo sea anónimo</label>
                            </div>
                        </div>
                        <input type="hidden" id="listado"/>
                        <input type="hidden" id="banco"/>
                        <input type="hidden" id="producto"/>
                        <input type="hidden" id="franquicia"/>
                        <input type="hidden" id="tipo"/>
                        <input type="hidden" id="contact_id"/>
                        <input type="hidden" id="deal_id"/>
                        <input type="hidden" id="table"/>

                        <button onClick={handlePayment}>
                            Pagar
                        </button>
                    </div>
                </div>
                <div className="step-3 d-none">
                    <img src={aceptado} alt=""/>
                    <h3>Pago exitoso</h3>
                    <h3>Datos de facturación</h3>
                    <div className="bank-datas">
                        <div className="datas">
                            <div className="data">
                                <label htmlFor="">
                                    Correo:
                                </label>
                                <input type="text" id="invoice_email" onFocus={handleFocus} onKeyUp={handleEmail} onBlur={handleBlur}/>
                            </div>
                            <div className="data">
                                <label htmlFor="">
                                    RFC:
                                </label>
                                <input type="text" id="rfc" onFocus={handleFocus} onKeyUp={handleRFC} onBlur={handleBlur}/>
                            </div>
                            <div className="data">
                                <label htmlFor="">
                                    Razón social:
                                </label>
                                <input type="text" id="razon_social" onFocus={handleFocus} onKeyUp={handleRazonSocial} onBlur={handleBlur}/>
                            </div>
                            <div className="data">
                                <label htmlFor="">
                                    Código postal fiscal:
                                </label>
                                <input type="text" id="cp_fiscal" onFocus={handleFocus} onKeyUp={handleCP} onBlur={handleBlur}/>
                            </div>
                            <div className="data filled is-valid">
                                <label htmlFor="">
                                    Regimen fiscal:
                                </label>
                                <select name="regimen_fiscal" id="regimen_fiscal" onChange={handleChange}>
                                    <option value="601 - General de Ley Personas Morales">601 - General de Ley Personas Morales</option>
                                    <option value="603 - Personas Morales con Fines no Lucrativos">603 - Personas Morales con Fines no Lucrativos</option>
                                    <option value="605 - Sueldos y Salarios e Ingresos Asimilados a Salarios">605 - Sueldos y Salarios e Ingresos Asimilados a Salarios</option>
                                    <option value="606 - Arrendamiento">606 - Arrendamiento</option>
                                    <option value="608 - Demás ingresos">608 - Demás ingresos</option>
                                    <option value="609 - Consolidación">609 - Consolidación</option>
                                    <option value="610 - Residentes en el Extranjero sin Establecimiento Permanente en México">610 - Residentes en el Extranjero sin Establecimiento Permanente en México</option>
                                    <option value="611 - Ingresos por Dividendos (socios y accionistas)">611 - Ingresos por Dividendos (socios y accionistas)</option>
                                    <option value="612 - Personas Físicas con Actividades Empresariales y Profesionales">612 - Personas Físicas con Actividades Empresariales y Profesionales</option>
                                    <option value="614 - Ingresos por Intereses">614 - Ingresos por Intereses</option>
                                    <option value="615 - Régimen de los ingresos por obtención de premios">615 - Régimen de los ingresos por obtención de premios</option>
                                    <option value="616 - Sin obligaciones fiscales">616 - Sin obligaciones fiscales</option>
                                    <option value="620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos">620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos</option>
                                    <option value="621 - Incorporación Fiscal">621 - Incorporación Fiscal</option>
                                    <option value="622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras">622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras</option>
                                    <option value="623 - Opcional para Grupos de Sociedades">623 - Opcional para Grupos de Sociedades</option>
                                    <option value="624 - Coordinados">624 - Coordinados</option>
                                    <option value="625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas">625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas</option>
                                    <option value="626 - Régimen Simplificado de Confianza">626 - Régimen Simplificado de Confianza</option>
                                </select>
                            </div>
                        </div>
                        <div className="invoice-buttons">
                            <button onClick={sendDatas}>
                                Realizar factura
                            </button>
                            <button onClick={sendToGeneral}>
                                No tengo mis datos ahora
                            </button>
                            <button onClick={sendToGeneralPublic}>
                                No requiero factura
                            </button>
                        </div>
                    </div>
                </div>
                {/*<FondoCopos copitos={100} />*/}
            </div>
        );
    }
}